import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../../../api';
import { localConfig } from '../../../../Configs/localConfig';
import { destroyAlert, errorAlert, loadingAlert, successAlert } from '../../../../utils/alert';
import { isArray } from 'lodash';


//#region EXCLUIR INSUMO DEFENSIVO
//INTERFACE
interface ParamsDeletarDefensivo {
    cod_insumo_defensivo: number,
    refetch_data_insumos_defensivos: Function
}
export const useDeleteInsumoDefensivo = (): {
    carregando_excluir_defensivo: boolean;
    mutate_excluir_defensivo: (params: ParamsDeletarDefensivo) => void;
    isSuccess_excluir_defensivo: boolean
} => {


    const mutation: UseMutationResult<Response, Error, ParamsDeletarDefensivo> = useMutation(
        async (params: ParamsDeletarDefensivo) => {

            const { cod_insumo_defensivo, refetch_data_insumos_defensivos } = params;

            loadingAlert({ msg: 'Salvando...', id: 'loading', autoClose: 10000 });

            if (cod_insumo_defensivo === null || cod_insumo_defensivo === undefined) {
                errorAlert('O Defensivo não foi informado!');
                return;
            }

            return api.delete(`recomendacao/insumo-agricola/${cod_insumo_defensivo}?codConta=${localConfig().conta}`)
                .then((response: any) => {
                    successAlert(`Insumo defensivo excluído com sucesso!`, 5000, 'loading');
                    refetch_data_insumos_defensivos();
                    return response;
                })
                .catch((error: any) => {

                    let error_msg = error?.response?.data?.error;

                    if (error_msg?.delete) {
                        destroyAlert('loading');
                        return;
                    }

                    errorAlert("Falha ao excluir defensivo!", 5000, 'loading');

                    // let error_msg = error?.response?.data?.error; 

                    if (isArray(error_msg)) {
                        for (const error_item of error_msg) {
                            errorAlert(error_item?.msg?.[0] ?? error_item, 8000)
                        }
                    } else {
                        errorAlert((error?.response?.data?.error) ?? 'Falha ao excluir defensivo!')
                    }

                    throw error;
                });
        }
    );

    return {
        carregando_excluir_defensivo: mutation.isLoading,
        mutate_excluir_defensivo: mutation.mutate,
        isSuccess_excluir_defensivo: mutation.isSuccess
    };
};
//#endregion